import React  from 'react';
import Button from '@material-ui/core/Button';

class Header extends React.Component{
    
    render(){


        if(this.props.data){
            var networks = this.props.data.social.map(function(network){
                return <li key={network.name}><a  target="_blank" rel="noopener noreferrer" href={network.url}><i className={network.className}></i></a></li>
              })
        }

        var style={
            color:'#ffffff'
        }
        var btnENG ={
            height: '40px',
            backgroundImage: 'url(images/ENG.PNG)',
            border:'none',
            borderRadius:'10px',
            outline:'none',
            cursor:'pointer',
        }
        var btnDE ={
            height: '40px',
            backgroundImage: 'url(images/DE.PNG)',
            border:'none',
            borderRadius:'10px',
            outline:'none',
            cursor:'pointer', 
        }       
        return(
            <header id="home">
                
                <nav id="nav-wrap">

                    <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
                    <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>
                    <ul id="nav" className="nav">
                        <li className="current"><a className="smoothscroll" href="#home">
                        {this.props.isGerman ? "Startseite" : "Home"}</a></li>
                        <li><a className="smoothscroll" href="#about">
                        {this.props.isGerman ? "Persönlich Angaben" : "About"}</a></li>
                        <li><a className="smoothscroll" href="#resume">
                        {this.props.isGerman ? "Lebenslauf" : "Resume"}</a></li>
                        <li><a className="smoothscroll" href="#interests">
                        {this.props.isGerman ? "Besondere Tätigkeiten" : "Extracurricular Activities"}</a></li>
                        <li><a className="smoothscroll" href="#work">
                        {this.props.isGerman ? "Berufserfahrung" : "Work"}</a></li>
                        <li><a className="smoothscroll" href="#bachelor"> 
                        {this.props.isGerman ? "Bachelor" : "Bachelor"}</a></li>
                    </ul>
                </nav>
                <div className="row banner">
                    <div className="banner-text">
                        <h1 className="responsive-headline">{this.props.isGerman ? "Ich bin " : "I'm "}Youssef William</h1>
                        <h2><span style={style}>{this.props.isGerman ? "Ich bin ein Software-Ingenieur" : "I'm a Software Engineer"}</span></h2>
                        <h3><span>{this.props.isGerman ? "Willkommen auf meiner Website" : "Welcome to my website"}</span></h3>
                        <hr />
                            <ul className="social">
                                {networks}
                            </ul>  
                            <hr />

                        
                           <h3><span> {this.props.isGerman ? "Ist auch auf Englisch erhältlich" : "Also available in German"}</span></h3>
                        
                            <Button style={this.props.isGerman ? btnENG : btnDE} type="submit" onClick={() => this.props.handler()}></Button>
                            
                            </div>

                </div>
                <p className="scrolldown">
                    <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
                </p>
            </header>

        );
    }
}
export default Header;